import { EM_DASH, fmtCost } from "../lib/format";

interface Props {
  usd: number | null | undefined;
  /** True when the zero is a verified fact (local text layer, Tesseract). */
  verifiedFree?: boolean;
  /** False when nothing was logged at all -- unrecorded, not free. */
  recorded?: boolean;
}

/**
 * A cost, with the three cases kept apart:
 *
 *   $0.000716  a real, priced cost
 *   $0.00 free the work genuinely cost nothing, and we can prove it
 *   —          either no rate is on file, or nothing was recorded
 *
 * Collapsing any of these into "$0.00" is what turns a cost report into a
 * guess, so the tooltip always says which case applies.
 */
export function CostCell({ usd, verifiedFree, recorded = true }: Props) {
  if (!recorded) {
    return (
      <span className="muted" title="No usage was recorded for this document. This is not the same as free.">
        {EM_DASH} <span className="muted">unrecorded</span>
      </span>
    );
  }

  if (usd === null || usd === undefined) {
    return (
      <span className="muted" title="Tokens were spent, but no price is on file for this model, so the cost is unknown. It is excluded from totals rather than counted as zero.">
        {EM_DASH} <span className="muted">no rate</span>
      </span>
    );
  }

  if (usd === 0 && verifiedFree) {
    return (
      <span title="Ran locally with no model call, so this zero is a fact rather than a missing rate.">
        $0.00 <span className="muted">free</span>
      </span>
    );
  }

  return <span>{fmtCost(usd)}</span>;
}
